<template functional>
  <div class="campaign-item-name">
    <router-link
      :to="{
        name: 'Campaign',
        params: { id: props.campaign.campaign_id, type: props.trafficSourceType.uniqueName },
        query: { type: props.trafficSourceType.id, account: props.campaign.traffic_source_account_id, tracker: props.campaign.tracker_account_id || 0, startDate: props.route.query.startDate || props.moment(new Date()).format('YYYY-MM-DD'), endDate: props.route.query.endDate || props.moment(new Date()).format('YYYY-MM-DD') }
      }"
    >
      <div class="d-flex align-items-center campaign-name">
        <img
          v-if="props.trackerAccountsMap[props.campaign.tracker_account_id]"
          v-b-tooltip="{ title: props.trackerAccountsMap[props.campaign.tracker_account_id].name, placement: 'top', delay: { show: 0, hide: 0 }, boundary: 'window' }"
          style="width: 20px;"
          class="mr-2"
          :src="`/sh_static/accounts/${props.trackerAccountsMap[props.campaign.tracker_account_id].type.uniqueName}.png`"
        >
        <span :title="props.campaign.name">{{ props.campaign.name }} </span>
      </div>
    </router-link>
    <div class="flags">
      <div v-if="!props.campaign.is_whitelist" v-b-tooltip.hover.bottomleft class="flag-item label-red" title="Blacklist">B</div>
      <div v-else-if="props.campaign.is_whitelist" v-b-tooltip.hover.bottomleft class="flag-item label-light-blue" title="Whitelist">W</div>
      <div v-if="props.campaign.unmanaged" v-b-tooltip.hover.bottomleft class="flag-item label-gray" title="Campaign is not managed by Optimizer">U</div>
      <template v-if="props.campaignRulesMap[props.campaign.campaign_id] && props.campaignRulesMap[props.campaign.campaign_id].find(rule => rule.rule_action !== 'day_parting')">
        <div :id="`rule-${props.campaign.campaign_id}`" class="flag-item label-blue">R</div>
        <b-popover :target="`rule-${props.campaign.campaign_id}`" triggers="hover focus">
          <template slot="title">Has active rules</template>
          <template v-for="(rule, index) in props.campaignRulesMap[props.campaign.campaign_id]">
            <p v-if="rule.rule_action !== 'day_parting'" :key="index" class="mb-1">
              <small>- {{ rule.name }}</small>
            </p>
          </template>
        </b-popover>
      </template>
      <div
        v-if="props.campaignRulesMap[props.campaign.campaign_id] && props.campaignRulesMap[props.campaign.campaign_id].find(rule => rule.rule_action === 'day_parting')"
        v-b-tooltip.hover.bottomleft
        class="flag-item label-blue-steel flag-item-icon"
        title="Dayparting Enabled"
      >
        <i class="fa fa-th-large" aria-hidden="true" />
      </div>
      <div v-if="props.campaign.duplicate" v-b-tooltip.hover.bottomleft class="flag-item label-purple-plum" title="Campaign is duplicated">D</div>
      <div v-if="props.campaign.manual_connected" v-b-tooltip.hover.bottomleft class="flag-item label-orange" title="Manual connected">M</div>
      <div v-if="props.campaign.archived" v-b-tooltip.hover.bottomleft class="flag-item label-black" title="Archived">A</div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CampaignName',
  props: {
    campaign: { type: Object, required: true },
    trafficSourceType: { type: Object, required: true },
    trackerAccountsMap: { type: Object, required: true },
    campaignRulesMap: { type: Object, required: true },
    route: { type: Object, required: true },
    moment: { type: Function, required: true },
  },
};
</script>

<style lang="scss">
  .campaign-item-name {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    overflow: hidden;
  }
</style>
